import { Component, Injectable, inject } from "@angular/core";
import { LgTranslateService, useTranslationNamespace } from "@logex/framework/lg-localization";
import { getDialogFactoryBase, IDialogComponent, LgDialogRef } from "@logex/framework/ui-core";
import { AvailableApplicationRole, BusinessRole } from "../../../shared/types";
import { OrganizationPermissionService } from "../../../shared/authorization";
import { PivotBRDetailProduct } from "./pivot/business-role-detail-pivot.types";
import { BusinessRoleDetailPivot } from "./pivot/business-role-detail-pivot";
import { LogexPivotService } from "@logex/framework/lg-pivot";
import { keyBy } from "lodash";
import { getAppRoleKey } from "../../../shared/helpers/application-role-key";

@Component({
    selector: "app-business-role-detail-dialog",
    templateUrl: "./business-role-detail-dialog.component.html",
    styleUrls: ["./business-role-detail-dialog.component.scss"],
    providers: [useTranslationNamespace("APP._Dialogs.BusinessRoleDetailDialog")],
    host: {
        class: "flex-flexible flexcol flexcol--full"
    },
    standalone: false
})
export class BusinessRoleDetailDialogComponent implements IDialogComponent<
    BusinessRoleDetailDialogComponent,
    boolean
> {
    private _organizationPermissionService = inject(OrganizationPermissionService);
    private _dialogRef = inject<LgDialogRef<BusinessRoleDetailDialogComponent>>(LgDialogRef);
    private _translate = inject(LgTranslateService);
    _pivot = inject(BusinessRoleDetailPivot);
    private _pivotService = inject(LogexPivotService);

    _dialogClass = "lg-dialog lg-dialog--3col";
    _dialogButtons = undefined;
    _title = "";

    _canEdit: boolean;
    _showEdit!: boolean;

    _businessRole!: BusinessRole;
    _pivotData: PivotBRDetailProduct[] = [];
    _availableAppRoles!: Record<string, AvailableApplicationRole>;

    constructor() {
        this._canEdit = this._organizationPermissionService.canEdit;
    }

    private _resolve!: (result: boolean) => void;

    private _createPromise(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this._resolve = resolve;
        });
    }

    show(
        businessRole: BusinessRole,
        availableAppRoles: AvailableApplicationRole[],
        showEdit: boolean = true
    ): Promise<boolean> {
        this._title = this._translate.translate(".Title", { name: businessRole.displayName });
        this._businessRole = businessRole;
        this._availableAppRoles = keyBy(availableAppRoles, item => getAppRoleKey(item));
        this._showEdit = showEdit;
        this._pivotData = this._pivotService.build(
            this._pivot.definition,
            this._businessRole.applicationRoles,
            null,
            this
        );

        return this._createPromise();
    }

    _edit(): void {
        this._resolve(true);
        this._dialogRef.close();
    }

    _close(): void {
        this._dialogRef.close();
    }
}

@Injectable()
export class BusinessRoleDetailDialog extends getDialogFactoryBase(
    BusinessRoleDetailDialogComponent,
    "show"
) {}
